import { FOUNDATION } from 'config/features';
import Duck from 'extensible-duck';
import genericEntityDuck, { withHooks } from '../../util/genericEntityDuck';
import { getActiveRole, setActiveRole } from '../api/localStorage';
import { FOUNDATION_OWNER_ORG, USER_ROLES } from '../domain/user';

const storeKey = 'user';
const namespace = 'app';

const getOrganizationUrlParam = () => {
  const url = new URL(globalThis.location.toString());
  return url.searchParams.get('organization');
};

const duck = withHooks(
  genericEntityDuck(namespace, storeKey, 'id', namespace).extend({
    types: ['SET_ACTIVE_ROLE'],
    initialState: {
      data: {},
      activeRole: null,
    },
    reducer: (state, action, { types: typesInput }) => {
      switch (action.type) {
        case typesInput.SET_ACTIVE_ROLE:
          setActiveRole(action.role);
          return {
            ...state,
            activeRole: action.role,
          };
        case typesInput.FETCH_SUCCESS: {
          const user = action.data;
          const storedRole = getActiveRole();
          const orgShortNameParam = getOrganizationUrlParam();
          const defaultOrgId = storedRole ? storedRole.organizationId : user.organizationId;
          const activeRole =
            action.data.roles.find(item => item.organizationDetails.shortName === orgShortNameParam) ||
            action.data.roles.find(item => item.organizationId === defaultOrgId) ||
            action.data.roles.find(item => item.organizationId === user.organizationId);
          setActiveRole(activeRole);
          return {
            ...state,
            activeRole,
          };
        }

        default: {
          return state;
        }
      }
    },
    selectors: {
      user: new Duck.Selector(selectorsInput => state => selectorsInput.data(state)),
      isInitialized: new Duck.Selector(selectorsInput => state => selectorsInput.initialized(state)),
      isAdmin: new Duck.Selector(selectorsInput => state => {
        const user = selectorsInput.user(state);
        return (
          (user?.roles &&
            user.roles.length >= 1 &&
            user.roles.some(
              ({ role, organizationId }) => user.organizationId === organizationId && role === USER_ROLES.ADMIN
            )) ||
          false
        );
      }),
      isOperator: new Duck.Selector(selectorsInput => state => {
        const user = selectorsInput.user(state);
        return (
          (user?.roles &&
            user.roles.length >= 1 &&
            user.roles.some(
              ({ role, organizationId }) => user.organizationId === organizationId && role === USER_ROLES.OPERATOR
            )) ||
          false
        );
      }),
      isOwner: new Duck.Selector(selectorsInput => state => {
        const user = selectorsInput.user(state);
        if (FOUNDATION) {
          return (
            user.shortName === FOUNDATION_OWNER_ORG &&
            user.roles &&
            user.roles.some(
              ({ role, organizationDetails }) =>
                organizationDetails.name === FOUNDATION_OWNER_ORG && role === USER_ROLES.ADMIN
            )
          );
        }
        return (
          (user.organizationId === 1 || user.organizationId === '1') &&
          user.roles &&
          user.roles.some(
            ({ role, organizationId }) => (organizationId === 1 || organizationId === '1') && role === USER_ROLES.ADMIN
          )
        );
      }),
      isAdminInOrganization: new Duck.Selector(selectorsInput => state => {
        const user = selectorsInput.user(state);
        const activeRole = selectorsInput.activeRole(state);
        return (
          (user?.roles &&
            user.roles.length >= 1 &&
            user.roles.some(
              ({ role, organizationId }) => organizationId === activeRole.organizationId && role === USER_ROLES.ADMIN
            )) ||
          false
        );
      }),
      isOperatorInOrganization: new Duck.Selector(selectorsInput => state => {
        const user = selectorsInput.user(state);
        const activeRole = selectorsInput.activeRole(state);
        return (
          (user?.roles &&
            user.roles.length >= 1 &&
            user.roles.some(
              ({ role, organizationId }) => organizationId === activeRole.organizationId && role === USER_ROLES.OPERATOR
            )) ||
          false
        );
      }),
      isDeployerInOrganization: new Duck.Selector(selectorsInput => state => {
        const user = selectorsInput.user(state);
        const activeRole = selectorsInput.activeRole(state);
        return (
          (user?.roles &&
            user.roles.length >= 1 &&
            user.roles.some(
              ({ role, organizationId }) => organizationId === activeRole.organizationId && role === USER_ROLES.DEPLOYER
            )) ||
          false
        );
      }),
      permissions: new Duck.Selector(selectorsInput => state => {
        return selectorsInput.data(state).permissions;
      }),
      roles: new Duck.Selector(selectorsInput => state => selectorsInput.user(state).roles),
      activeRole: new Duck.Selector(selectorsInput => state => selectorsInput.entities(state).activeRole),
      organizationShortName: new Duck.Selector(selectorsInput => state => {
        const activeRole = selectorsInput.activeRole(state);
        return activeRole ? activeRole.organizationDetails.shortName : null;
      }),
    },
    creators: ({ types: typesInput }) => ({
      setActiveRole: role => ({ type: typesInput.SET_ACTIVE_ROLE, role }),
    }),
  })
);

export { duck as default, storeKey };
export const { creators, reducer, types, selectors, hooks } = duck;
